import type { Nullable } from '~/types/Nullable';
import type { User } from '~/types/User';

export type SegmentIdentityEventProperties = {
  user_id: string;
  client_id: number;
  group_id: number;
  client_name: string;
};

export function getSegmentIdentityEventProperties(
  user?: Nullable<User>,
): SegmentIdentityEventProperties | null {
  return buildSegmentIdentity(user?.id, user?.client, user?.client_name);
}

export function buildSegmentIdentity(
  userId?: number,
  clientId?: number,
  clientName?: string,
): SegmentIdentityEventProperties | null {
  if (!userId || !clientId) {
    return null;
  }

  return {
    user_id: String(userId),
    client_id: clientId,
    group_id: clientId,
    client_name: clientName ?? '',
  };
}

export function isAutomationCustomAiPath(pathname: string): boolean {
  return /\/(automation|custom-ai)(\/|$)/.test(pathname);
}
